export const protocol = "https";
export const host = "api.skylinetechnology.co";
export const port = "";
export const trailUrl = "";
// export const protocol = "http";
// export const host = "192.168.29.234";
// export const port = "4000";
// export const trailUrl = "";